import { useState , useEffect } from 'react';
import useSizeColor from 'newHooks/useSizeColor';
import { priceFormat } from 'util/prices';
import { repareImage } from 'newFunctions/repareDataService';
import ModalProductTC from '../../Modal'
import styles from '../styles.module.sass'

const ProductModal = (props) => {

    const {
        modalTC = false,
        handleClose,
        isMobile,
        title,
        product,
        clickAddProduct,
        image
    } = props
    

    const [ picture, setPicture ] = useState(null)
    useEffect(()=>{
        if(product?.showModal){
            // console.log('image: ',image)
            // console.log('product: ',product)
            // console.log('product source: ',product?.variants?.pictures[0]?.source)
        }
        if(image){
            if(image !== true){
                setPicture(image)
            }else{
                setPicture(product?.variants?.pictures[0]?.source)
            }
        }else{
            setPicture(product?.variants?.pictures[0]?.source)
        }

    }, [product?.showModal])


    return(
        product?.showModal
            ? 
                <ModalProductTC
                    onClose={handleClose} 
                    isMobile={isMobile} 
                    type={isMobile === 'desktop' ? '' : 'full'} 
                    title={title} 
                    closeBody="modalPromos"
                >
                    {modalTC
                        ?
                            <ProdModalTC 
                                producto={product?.variants}
                                handleClose={handleClose}
                                clickAddProductTC={clickAddProduct}
                                image={picture}
                            />
                        :
                            <ProdModal
                                producto={product?.producto}
                                handleClose={handleClose}
                                clickAddProduct={clickAddProduct}
                                image={picture}
                            />
                    }
                </ModalProductTC>
            : null
    )   
}

const ProdModal = (props) => {
    const {
        producto,
        handleClose,
        clickAddProduct,
        image
    } = props


    return(
        <article className={styles?.cardModalProduct}>
            <div onClick={handleClose} className={styles?.closeBtn} aria-hidden >X</div>
            {producto?.pricing?.percentage_discount
                ?
                    <p className={styles?.discount}>-{producto?.pricing?.percentage_discount}%</p>
                : null
            }
            
            <div className={styles?.contImages}>
                <img src={repareImage(image)} alt={producto?.title} className={styles?.imageProduct} loading="lazy" decoding="async" fetchPriority="High" />
                <a href={`/producto/${producto?.id}/${producto?.title_seo}`} alt={producto?.title} target="_blank" className={styles?.link} rel="noreferrer" >Ver detalle</a>
            </div>
            
            <div className={styles?.contProductInt}>
                <p className={styles?.title}>{producto?.title}</p>
                <div className={styles?.reviews}>
                    <div>
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews >= 1 ? producto?.rating?.average_score <= 4 ?  'fa fa-lg fa-star-o' : 'fa fa-lg fa-star' : 'fa fa-lg fa-star-o'} />
                    </div>
                    ({producto?.rating?.total_reviews})
                </div>
                <div className={styles?.contPrices}>
                    {producto?.pricing?.list_price !== producto?.pricing?.sales_price
                        ?
                            <p className={styles?.price}>${priceFormat(producto?.pricing?.list_price)}</p>
                        : null
                    }
                    <p className={styles?.salesPrice}>${priceFormat(producto?.pricing?.sales_price)} MXN</p>
                </div>

                <p className={styles?.description}>{producto?.description}</p>
                <div>
                    <div className="btn primaryButton btn-block" onClick={clickAddProduct} aria-hidden="true" >Agregar</div>
                </div>
            </div>
        </article>
    )
}

const ProdModalTC = (props) => {
    const {
        producto,
        handleClose,
        clickAddProductTC,
        image
    } = props

    const [ selectedSizeColros, setSelectedSizeColros ] = useState(null)

    return(
        <article className={styles?.cardModalProduct}>
            <div onClick={handleClose} className={styles?.closeBtn} aria-hidden >X</div>
            {producto?.pricing?.percentage_discount
                ?
                    <p className={styles?.discount}>-{producto?.pricing?.percentage_discount}%</p>
                : null
            }
            
            <div className={styles?.contImages}>
                <img src={repareImage(image)} alt={producto?.title} className={styles?.imageProduct} loading="lazy" decoding="async" fetchPriority="High" />
                <a href={`/producto/${producto?.id}/${producto?.title_seo}`} alt={producto?.title} target="_blank" className={styles?.link} rel="noreferrer" >Ver detalle</a>
            </div>
            
            <div className={styles?.contProductInt}>
                <p className={styles?.title}>{producto?.title}</p>
                <div className={styles?.reviews}>
                    <div>
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews === 0 ? 'fa fa-lg fa-star-o' : 'fa fa-lg fa-star'} />
                        <span className={producto?.rating?.total_reviews >= 1 ? producto?.rating?.average_score <= 4 ?  'fa fa-lg fa-star-o' : 'fa fa-lg fa-star' : 'fa fa-lg fa-star-o'} />
                    </div>
                    ({producto?.rating?.total_reviews})
                </div>
                <div className={styles?.contPrices}>
                    {producto?.pricing?.list_price !== producto?.pricing?.sales_price
                        ?
                            <p className={styles?.price}>${priceFormat(producto?.pricing?.list_price)}</p>
                        : null
                    }
                    <p className={styles?.salesPrice}>${priceFormat(producto?.pricing?.sales_price)} MXN</p>
                </div>
                <SizeColor 
                    sizeColor={producto?.tallaColor}
                    setSelectedSizeColros={setSelectedSizeColros}
                />
                <p className={styles?.description}>{producto?.description}</p>
                <div>
                    <div className={selectedSizeColros ? 'btn primaryButton btn-block' : 'btn primaryButton disabled btn-block' } onClick={() => clickAddProductTC(selectedSizeColros)} aria-hidden="true" >Agregar</div>
                </div>
            </div>
        </article>
    )
}

const SizeColor = (props) => {
    const {
        sizeColor,
        setSelectedSizeColros
    } = props

    const {
        colors,
        sizes,
        selectedSizeColros,
        setSelectColor,
        setSelectSize
    } = useSizeColor(sizeColor)

    useEffect(()=>{
        setSelectedSizeColros(selectedSizeColros)
    },[selectedSizeColros])

    const handleChangeColor = (event) => {
        const color = event.target.value
        const selectTalla = document.querySelector('#tallas')
        if(selectTalla != null){
            selectTalla.selectedIndex = 0
        }
        setSelectColor( color )
    }

    const handleChangeTallas = (event) => {
        const tallas = event.target.value
        const variacion = tallas.split('|')

        const selectSize = {
            sku: variacion[0], 
            id: variacion[1]
        }
        setSelectSize( selectSize )
    }

    return(
        <>
            <div className={styles?.contSelect}>
                {colors
                    ?
                        colors?.length > 1
                            ?
                                <select  name="colores" id="colores" className={styles?.select} onChange={ handleChangeColor }>
                                    <option selected disabled>Colores</option>
                                    {
                                         colors.map( color => (  <option key={color} value={color}>{color}</option> ) )
                                    }
                            
                                </select>
                            : 
                                <p className={styles?.select} onClick={ () => setSelectColor( colors[0] ) } aria-hidden >{ colors[0] }</p>
                    : null
                }
                {sizes
                    ?
                        sizes?.length > 1
                            ?
                                <select  name="tallas" id="tallas" className={styles?.select} onChange={ handleChangeTallas }>
                                    <option selected disabled>Tallas</option>
                                    {
                                        sizes.map( tallas => ( <option key={tallas?.sku} value={`${tallas?.sku}|${tallas?.id}`}>{tallas?.size}</option> ) )
                                    }
                                </select>
                            : 
                                <p className={styles?.select} onClick={ () => setSelectSize({sku: sizes[0]?.sku, id: sizes[0]?.id}) } aria-hidden>{sizes[0]?.size}</p>
                    : <select name="tallas" id="tallas" className={styles?.select} >
                        <option selected disabled>Tallas</option>
                    </select>
                }
            </div>
        </>
    )
}

export default ProductModal